import { UtilitiesService } from "./UtilitiesService";

const requestInit = {
    method: "GET", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    redirect: "follow", // manual, *follow, error
    referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
}

const AuthService = {

    /**
     * Resolves to a usable booking token, fetching a fresh one from the API when there's no
     * cached token or the cached one has expired. Unlike a cached Promise, this re-checks
     * sessionStorage on every call, so invalidateToken() below can force the next call to
     * fetch a new token instead of replaying a stale one for the rest of the page's lifetime.
     */
    async getToken(): Promise<string> {
        const tokenJson = window.sessionStorage.getItem('tokenObj');

        if (tokenJson) {
            const tokenObj = JSON.parse(tokenJson);
            const expiredAt = new Date(tokenObj.expiry);

            if (expiredAt > new Date()) { // Validate expiry date.
                return tokenObj.token;
            }

            window.sessionStorage.removeItem('tokenObj');
        }

        const baseUrl = UtilitiesService.getApiUrl();
        const url = baseUrl + "/api/booking/get-token";

        const response = await fetch(url, requestInit as RequestInit);
        const string = await response.text();

        if (!response.ok || string === "") {
            throw new Error('Unable to obtain a booking token');
        }

        const json = JSON.parse(string);
        window.sessionStorage.setItem('tokenObj', string);

        return json.token;
    },

    /**
     * Drops the cached token so the next getToken() call fetches a fresh one instead of
     * reusing one the API just rejected (e.g. on a 401/403 response).
     */
    invalidateToken(): void {
        window.sessionStorage.removeItem('tokenObj');
    }
};

export default AuthService;